import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, ExternalLink } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_ima-montaz-preview/artifacts/e8el7v59_Logo%20Imamontaz.png";

const footerLinks = {
  company: [
    { name: 'Tentang Kami', path: '/tentang' },
    { name: 'Kapabilitas', path: '/kapabilitas' },
    { name: 'Sertifikasi', path: '/sertifikasi' },
    { name: 'Klien', path: '/klien' },
  ],
  products: [
    { name: 'Precision Parts', path: '/produk-layanan' },
    { name: 'Pump System', path: '/produk-layanan' },
    { name: 'Gear & Gearbox', path: '/produk-layanan' },
    { name: 'Valve', path: '/produk-layanan' },
  ],
  services: [
    { name: 'Precision Machining', path: '/kapabilitas' },
    { name: 'Metal Fabrication', path: '/kapabilitas' },
    { name: 'Equipment Repair', path: '/kapabilitas' },
    { name: 'Engineering Solutions', path: '/kapabilitas' },
  ],
};

export const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-[#001582] to-[#000d5c] text-white" data-testid="footer">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="mb-6">
              <img 
                src={LOGO_URL} 
                alt="PT IMA MONTAZ TEKNINDO" 
                className="h-14 w-auto"
              />
            </div>
            <p className="text-slate-300 text-sm leading-relaxed mb-6">
              Perusahaan engineering yang bergerak di bidang supply, manufacture, dan repair mechanical electrical equipment parts serta fabricated metal product untuk industri oil & gas dan sektor industri lainnya.
            </p>
            <div className="flex items-center gap-3">
              <img 
                src="https://customer-assets.emergentagent.com/job_ima-montaz-preview/artifacts/xjkxagw1_ISO_.png" 
                alt="ISO 9001:2015" 
                className="h-14 w-auto rounded-lg bg-white p-1"
              />
              <span className="text-xs text-slate-400">ISO 9001:2015<br/>Certified</span>
            </div>
          </div>

          {/* Quick Links - Company */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-4 text-[#FFC107]">
              Perusahaan
            </h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.path}
                    className="text-slate-300 hover:text-white text-sm transition-colors flex items-center gap-2"
                  >
                    <span className="w-1.5 h-1.5 bg-[#FFC107] rounded-full" />
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links - Products */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-4 text-[#FFC107]">
              Produk
            </h4>
            <ul className="space-y-3">
              {footerLinks.products.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.path}
                    className="text-slate-300 hover:text-white text-sm transition-colors flex items-center gap-2"
                  >
                    <span className="w-1.5 h-1.5 bg-[#FFC107] rounded-full" />
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-4 text-[#FFC107]">
              Kontak
            </h4>
            <ul className="space-y-4">
              <li>
                <a 
                  href="tel:02182609241" 
                  className="text-slate-300 hover:text-white text-sm flex items-start gap-3 transition-colors"
                >
                  <Phone className="w-4 h-4 mt-0.5 text-[#FFC107] flex-shrink-0" />
                  <div>
                    <p>021-82609241</p>
                    <p>021-38716184</p>
                    <p>021-82595178</p>
                  </div>
                </a>
              </li>
              <li>
                <a 
                  href="mailto:admin@imamontaz.id" 
                  className="text-slate-300 hover:text-white text-sm flex items-center gap-3 transition-colors"
                >
                  <Mail className="w-4 h-4 text-[#FFC107] flex-shrink-0" />
                  admin@imamontaz.id
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-[#FFC107] flex-shrink-0" />
                <address className="text-slate-300 text-sm not-italic leading-relaxed">
                  Jl. Mawar No. 120A, RT.003/RW.006<br />
                  Mustikasari, Kec. Mustikajaya<br />
                  Kota Bekasi, Jawa Barat 17157
                </address>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-400 text-sm text-center md:text-left">
              &copy; {new Date().getFullYear()} PT IMA MONTAZ TEKNINDO. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a 
                href="https://imamontaz.id" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-white text-sm flex items-center gap-1 transition-colors"
              >
                www.imamontaz.id
                <ExternalLink className="w-3 h-3" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
